module.exports = __webpack_public_path__ + "static/media/hero-v-commerce.35886884.jpg";